import { render, staticRenderFns } from "./ConfidentialAccessPopup.vue?vue&type=template&id=b6840062"
import script from "./ConfidentialAccessPopup.vue?vue&type=script&setup=true&lang=js"
export * from "./ConfidentialAccessPopup.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports